'use client';

import {
  ProductDetails,
  type ProductDetailsProps,
} from '@hyphengroup/cms-components/components/ProductDetails/ProductDetails';
import { useMemo } from 'react';
import { usePageDataContext } from '$/(cms)/_modules/cmsService/pageDataService/pageDataProvider';
import { getLoanSearchParamsWithDefaultComponentParam } from '$/components/cms/helpers/loanSearchParams';
import { useLoanSearchParams } from '$/components/cms/helpers/useLoanSearchParams';
import { useClientContext } from '$/modules/context/client';

/**
 * PL PDP: injects the page's loan selection into ProductDetails — the same
 * `cms_amount`/`cms_tenure` URL params (over the page PL config and brand
 * defaults) that the PL listing modules read, so the Offers section and the
 * loan calculator share one selection.
 */
export const ProductDetailsWrapperPersonalLoan = (
  props: ProductDetailsProps,
): JSX.Element => {
  const { brand } = useClientContext();
  const {
    pageData: { plFilterConfig },
  } = usePageDataContext();

  const initialLoanSearchParams = useMemo(
    () =>
      getLoanSearchParamsWithDefaultComponentParam(brand, undefined, {
        amount: plFilterConfig?.default_loan_amount?.toString(),
        tenure: plFilterConfig?.default_loan_tenure?.toString(),
      }),
    [
      brand,
      plFilterConfig?.default_loan_amount,
      plFilterConfig?.default_loan_tenure,
    ],
  );

  const { loanSearchParams, setLoanSearchParams } = useLoanSearchParams(
    initialLoanSearchParams,
  );

  return (
    <ProductDetails
      {...props}
      loanSearchParams={loanSearchParams}
      onLoanSearchParamsChange={setLoanSearchParams}
    />
  );
};
